import React from 'react'
import * as C from "../componentsM/index";

const CodeOfConduct = () => {
    return (
        <>

            <C.Hero title={"CODE OF CONDUCT"} image={"/hero/20.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <h1 >
                        The purpose of the TIS Code of Conduct is to ensure that all students, parents, teachers and staff are aware of acceptable behaviour at The International School, and the repercussions for any inappropriate behaviour.
                    </h1>



                    <h1 >
                        The TIS Code of Conduct is based on three simple concepts that all students should follow:
                    </h1>



                    <ul className="list-disc list-inside my-2">
                        {[
                            "cooperation with teachers, administrators and peers",
                            "respect for the rights and property of others",
                            "to ensure that all students carry out their responsibilities"
                        ]
                            .map((item, index) => (
                                <li key={index} className="font-semibold">{item}</li>
                            ))}
                    </ul>



                    <h1 >
                        The TIS Code of Conduct is published annually for the entire school community.
                    </h1>







                </div>


            </section>

        </>
    )
}

export default CodeOfConduct